import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWizardHat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWizardHat"><Path fillRule="evenodd" clipRule="evenodd" d="M11.7246 1.48389L20.1499 9.16668H15.4265L19.9593 19.5H22V21H2V19.5H4.04126L7.11662 12.2888L7.19704 12.3264L7.99998 14.0468L8.80293 12.3264L10.5234 11.5234L8.80293 10.7205L8.27129 9.58133L11.7246 1.48389ZM13.8029 14.947L13 13.2266L12.197 14.947L10.4766 15.75L12.197 16.5529L13 18.2734L13.8029 16.5529L15.5234 15.75L13.8029 14.947Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWizardHat;
